<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/UsersEdit/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'user/edit'
    }
  },

  async created () {
    this.$store.dispatch(`${this.modelName}/get`, this.$route.params.id)
  }
}
</script>
